import {
  Airplay,
  PhoneOutgoing,
  Brush,
  WandSparkles,
  HandPlatter,
  Soup,
  Gamepad2,
  Medal,
  Images,
  MicVocal,
  Camera,
  Instagram,
  MessageCircleMore,
  Dumbbell,
  Trophy,
  MapPin,
  BaggageClaim,
  BatteryCharging,
  SquarePower,
  Bluetooth,
  Send,
  Newspaper,
  Paperclip,
  Stamp,
  DatabaseBackup,
  IterationCw,
  FlipVertical,
  Grab,
  Presentation,
  Milk,
  CookingPot,
  Croissant,
  Lollipop,
  Utensils,
  Vegan,
  Cake,
  Beer,
  Headset,
  Plus,
  Crown,
  Dices,
  Flame,
  Boxes,
  Star,
  Shapes,
  Popcorn,
  SquarePlay,
  Usb,
  Repeat,
  Pause,
  Music,
  Album,
  Heart,
  Backpack,
  Flashlight,
  Wand,
  RotateCcw,
  RotateCw,
  LayoutList,
  CameraOff,
  ZoomIn,
  MessageSquareHeart,
  HandHeart,
  Rss,
  ThumbsUp,
  Slack,
  SmilePlus,
  Share,
  Handshake,
  Award,
  LandPlot,
  Flower,
  ReceiptText,
  ShipWheel,
  Plane,
  Cigarette,
  FireExtinguisher,
  TentTree,
  ConciergeBell,
  Receipt,
} from "lucide-react";
import StatusFilter from "../../components/StatusFilter";
import useDebounce from "../ManageUsers/useDebounce";
import CommonPagination from "../../components/Table/CommonPagination";
import { limitChar } from "../../utils/common";
import CustomTextField from "../../components/FormElements/CustomTextField";
import OutlinedButton from "../../components/FormElements/Buttons/OutlinedButton";
import ContainedButton from "../../components/FormElements/Buttons/ContainedButton";
import { useDispatch } from "react-redux";
import { setLoading, showToast } from "../../store/slices/common";
import {
  Chat,
  Dance,
  Karaoke,
  Fashion,
  Food,
  Humour,
  Makeup,
} from "./CustomIcon";

export const iconMap = {
  Makeup: Makeup,
  Karaoke: Karaoke,
  Fashion: Fashion,
  Dance: Dance,
  Food: Food,
  Humour: Humour,
  Chat: Chat,
  Speech: Airplay,
  Video: PhoneOutgoing,
  "book-heart": Brush,
  "screen-share": WandSparkles,
  sticker: HandPlatter,
  "contact-round": Soup,
  "audio-waveform": Gamepad2,
  "battery-charging": BatteryCharging,
  "square-power": SquarePower,
  Bluetooth,
  Send,
  Newspaper,
  Brush,
  "wand-sparkles": WandSparkles,
  palette: HandPlatter,
  paperclip: Paperclip,
  stamp: Stamp,
  "database-backup": DatabaseBackup,
  "iteration-cw": IterationCw,
  "flip-vertical": FlipVertical,
  grab: Grab,
  presentation: Presentation,
  milk: Milk,
  "cooking-pot": CookingPot,
  croissant: Croissant,
  lollipop: Lollipop,
  utensils: Utensils,
  vegan: Vegan,
  Cake,
  beer: Beer,
  "gamepad-2": Gamepad2,
  medal: Medal,
  headset: Headset,
  plus: Plus,
  crown: Crown,
  dices: Dices,
  flame: Flame,
  boxes: Boxes,
  star: Star,
  shapes: Shapes,
  images: Images,
  "mic-vocal": MicVocal,
  popcorn: Popcorn,
  "square-play": SquarePlay,
  usb: Usb,
  repeat: Repeat,
  pause: Pause,
  music: Music,
  album: Album,
  Heart,
  camera: Camera,
  backpack: Backpack,
  flashlight: Flashlight,
  wand: Wand,
  "rotate-ccw": RotateCcw,
  "rotate-cw": RotateCw,
  "layout-list": LayoutList,
  "camera-off": CameraOff,
  "zoom-in": ZoomIn,
  Instagram,
  "message-circle-more": MessageCircleMore,
  "message-square-heart": MessageSquareHeart,
  "hand-heart": HandHeart,
  rss: Rss,
  "thumbs-up": ThumbsUp,
  Slack,
  "smile-plus": SmilePlus,
  Share,
  Handshake,
  Dumbbell,
  Trophy,
  award: Award,
  "land-plot": LandPlot,
  Flower,
  "map-pin": MapPin,
  "baggage-claim": BaggageClaim,
  "receipt-text": ReceiptText,
  "ship-wheel": ShipWheel,
  plane: Plane,
  cigarette: Cigarette,
  "fire-extinguisher": FireExtinguisher,
  "tent-tree": TentTree,
  "concierge-bell": ConciergeBell,
  Receipt,
};
